module.exports = __webpack_public_path__ + "img/repost.f36992e6.svg";